import { MSym } from '@storeo/ui';
import { DemoBanner, PlaceholderTag } from '../components/lumina/Placeholder';

/** Admin · Clientes & Alunos Global — nova (Fluxo 4 Fase 2), 100% ilustrativa. A Storeo não
 *  tem um índice global de compradores entre lojas (cada loja só vê os próprios clientes,
 *  `AccountAccess` é por tenant) nem player white-label com telemetria — não existe endpoint
 *  admin pra isso. Nomes/valores abaixo são fictícios de propósito (não CPF/e-mail reais). */
export function Clientes() {
  return (
    <>
      <div className="relative overflow-hidden rounded-2xl bg-surface-container-low p-space-xl shadow-xl">
        <div className="relative z-10 flex flex-col gap-space-2xs">
          <h1 className="font-headline-lg text-headline-lg text-on-surface font-bold flex items-center gap-2">
            Clientes & Alunos Global <PlaceholderTag />
          </h1>
          <p className="font-body-md text-body-md text-on-surface-variant">
            A Storeo não tem um índice global de compradores entre lojas — cada loja só enxerga os próprios clientes.
          </p>
        </div>
      </div>

      <DemoBanner>Nenhum dado real nesta tela — não existe endpoint admin pra clientes entre lojas. Tudo abaixo é ilustrativo.</DemoBanner>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-space-md">
        <Kpi icon="group" label="Compradores únicos" value="—" sub="sem índice global" />
        <Kpi icon="school" label="Alunos ativos" value="—" sub="sem índice global" />
        <Kpi icon="key" label="Chaves 1-clique salvas" value="—" sub="recurso não existe" />
        <Kpi icon="repeat" label="Recompra cross-store" value="—" sub="recurso não existe" />
      </div>

      <section className="bg-surface-container-low rounded-2xl p-space-md shadow-lg overflow-hidden">
        <div className="flex items-center gap-space-xs px-space-sm pb-space-sm">
          <MSym name="table_rows" className="text-primary text-[20px]" />
          <h2 className="font-headline-sm text-headline-sm text-on-surface font-bold">Compradores (exemplo)</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-outline font-label-sm text-label-sm uppercase tracking-wider bg-surface-container-lowest/60">
                <th className="py-space-sm px-space-md rounded-l-lg">Comprador</th>
                <th className="py-space-sm px-space-sm">Loja de origem</th>
                <th className="py-space-sm px-space-sm text-right">Pedidos</th>
                <th className="py-space-sm px-space-md text-right rounded-r-lg">LTV acumulado</th>
              </tr>
            </thead>
            <tbody className="text-body-sm font-body-sm opacity-70">
              {[
                { name: 'Comprador exemplo A', store: 'loja-exemplo-1.storeo.app', orders: 4, ltv: 'R$ 890,00' },
                { name: 'Comprador exemplo B', store: 'loja-exemplo-2.storeo.app', orders: 1, ltv: 'R$ 120,00' },
                { name: 'Comprador exemplo C', store: 'loja-exemplo-3.storeo.app', orders: 7, ltv: 'R$ 2.340,00' },
              ].map((r) => (
                <tr key={r.name} className="border-t border-surface-container-highest/20">
                  <td className="py-space-md px-space-md text-on-surface font-semibold">{r.name}</td>
                  <td className="py-space-md px-space-sm text-outline font-mono">{r.store}</td>
                  <td className="py-space-md px-space-sm text-right font-mono text-on-surface">{r.orders}</td>
                  <td className="py-space-md px-space-md text-right font-mono text-secondary font-bold">{r.ltv}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

function Kpi({ icon, label, value, sub }: { icon: string; label: string; value: string; sub: string }) {
  return (
    <div className="rounded-xl bg-surface-container-low p-space-md shadow-md flex flex-col gap-space-2xs">
      <div className="flex items-center justify-between">
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-outline">{label}</span>
        <MSym name={icon} className="text-[18px] text-outline" />
      </div>
      <span className="font-headline-sm text-headline-sm text-outline font-bold">{value}</span>
      <span className="text-[11px] text-on-surface-variant">{sub}</span>
    </div>
  );
}
